import script from "./idle.vue?vue&type=script&setup=true&lang=js"
export * from "./idle.vue?vue&type=script&setup=true&lang=js"

import "./idle.vue?vue&type=style&index=0&id=6f6c33b7&scoped=true&lang=css"

import exportComponent from "/home/dev.qpax-tcms.net/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f6c33b7"]])

export default __exports__